import type { Job } from 'types';
import { JobsInitialState } from 'types/reducers/jobs';

export const JOBS = {
  loading: false,
  error: false,
  jobs: [],
  totalJobs: 0,
};

const initialAlertsDetail = {
  recentPayload: {},
  isLoading: true,
  isSubscribed: false,
};
/**
 * Key for containing diff type of jobs with it's key and JOBS object.
 */
export const jobInitialState: JobsInitialState = {
  /**
   * key of type of jobs with jobs
   * EX. companyjobs, competiterJobs, relatedJobs for jobCards
   */
  companyJobs: JOBS,

  // user listing hash of jobs
  favoriteJobs: [],
  dismissedJobs: [],
  appliedJobs: [],
  viewedJobs: [],
  receivedPaidListingHashes: [],
  // store the most recent job
  recentFavoriteJob: {} as Job,
  recentDismissedJob: {} as Job,
  recentAppliedJob: {} as Job,
  recentViewedJob: {} as Job,
  currentPageCategory: '',
  paidJobs: JOBS,
  jobListDismiss: false,
  alertsDetail: initialAlertsDetail,
};
